import * as React from 'react';

const ComplokWalkingMobile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="1em" height="1em" viewBox="0 0 199 205" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M170.211 89.727c9.282-1.584 20.673-8.302 23.053-15.806 2.267-7.204-1.249-16.068-11.688-10.51-10.438 5.557-21.205 13.823-23.824 19.093-2.604 5.297 3.163 8.78 12.459 7.223zM75.796 183.908c-7.03-9.956-7.24-23.835 3.921-34.847 11.162-11.012 30.5-24.378 48.751-33.128 18.252-8.779 41.239-24.71 53.94-17.197 12.7 7.512 8.175 41.998-10.589 62.273-18.764 20.275-38.071 27.998-52.884 34.033-14.812 6.034-34.511 1.056-43.14-11.134zM22.005 134.743c-16.653-6.758-32.43-31.649-13.123-64.746C28.189 36.899 74.466 0 116.369 0c41.903 0 55.207 34.274 44.165 62.062-11.041 27.787-27.331 43.476-51.254 58.622s-58.526 25.705-87.275 14.059z"
      fill="#172845"
    />
    <path
      d="M30 127.442c12.188-13.396 24.105-23.382 29.263-16.413 7.3 9.866.422 25.193-10.619 33.128-11.041 7.935-22.173 9.896-26.698 4.073-4.495-5.853 2.986-15.206 8.055-20.788zM60.316 75.669s-.513.543-1.207 1.297c-.663.754-1.508 1.66-2.172 2.384-.663.724-1.508 1.629-2.172 2.353C54.102 82.457 53.59 83 53.59 83c-.06.09-.332-.15-.272-.21 0 0 .453-.635 1.056-1.419a33.933 33.933 0 012.082-2.504c.663-.724 1.568-1.6 2.323-2.293.754-.694 1.327-1.177 1.327-1.177.06-.03.272.212.211.272zM82.43 122.193s.06-.483.15-1.328c.091-.815.212-1.991.332-3.289.212-2.624.362-5.913.393-8.478.06-2.564.03-5.853-.121-8.478-.06-1.327-.15-2.474-.211-3.318-.06-.815-.12-1.328-.12-1.328-.031-.272.331-.302.361-.03a174.449 174.449 0 01.483 4.646c.211 2.655.332 5.944.302 8.539-.03 2.594-.272 5.883-.574 8.508-.15 1.327-.301 2.474-.422 3.288-.12.815-.211 1.328-.211 1.328-.09.271-.392.211-.362-.06z"
      fill="#172845"
    />
    <path
      d="M82.912 114.71s-.09 0-.271-.03c-.181-.03-.422-.061-.754-.121-.332-.09-.724-.211-1.086-.543-.362-.332-.604-.784-.815-1.267-.06-.121-.09-.272-.12-.423-.03-.15-.03-.271-.06-.422-.031-.271-.031-.543-.061-.815-.03-.543-.03-1.116-.03-1.689v-3.228c.03-1.962 0-4.466-.09-6.457-.031-.513-.031-.966-.061-1.388a42.16 42.16 0 00-.09-1.116c-.061-.634-.091-.996-.091-.996 0-.211.332-.241.362-.03l.15.996c.061.301.091.694.121 1.116.06.422.09.905.151 1.388.181 2.021.272 4.525.272 6.487 0 .995-.03 2.112-.06 3.228 0 .573-.03 1.116-.03 1.659 0 .543 0 1.086.12 1.479.15.452.362.844.633 1.116.272.272.604.392.875.483.302.09.543.12.694.151.181.03.272.03.272.03.21.09.18.392-.03.392zM75.946 121.046s.09-.03.242-.061c.09-.03.18-.03.301-.03s.242-.03.393-.03c.603-.03 1.417.06 2.322.362.906.272 1.84.724 2.746 1.237.905.513 1.75 1.056 2.474 1.569 1.478.996 3.258 2.414 4.645 3.62.694.604 1.267 1.147 1.69 1.539.422.392.663.634.663.634.121.12-.09.392-.241.271 0 0-.272-.211-.694-.603-.422-.362-1.056-.875-1.75-1.448a62.367 62.367 0 00-4.706-3.44c-1.448-.995-3.318-2.293-4.977-2.896a7.77 7.77 0 00-2.142-.453h-.362c-.121 0-.212 0-.272.03-.15.031-.241.031-.241.031-.211.03-.302-.272-.09-.332z"
      fill="#172845"
    />
    <path
      d="M75.88 118.33s.453 0 1.026.212a4.605 4.605 0 011.63.935c.422.362.874.935 1.206 1.388.332.452.543.814.543.814.03.061-.241.272-.271.212 0 0-.302-.302-.664-.694-.392-.393-.875-.875-1.267-1.207-.392-.332-.905-.724-1.388-.966-.482-.241-.875-.332-.875-.332-.03-.06 0-.362.06-.362zM71.57 121.89s-.18 0-.482.03c-.302.031-.724.091-1.207.181a16.66 16.66 0 00-2.956.906c-.875.362-1.93.905-2.715 1.448-.392.271-.724.543-.966.724-.24.211-.362.302-.362.302-.09.06-.331-.181-.24-.272 0 0 .12-.151.361-.362.211-.211.543-.513.935-.845.785-.633 1.87-1.297 2.776-1.659.905-.362 2.142-.694 3.137-.785.513-.06.935-.06 1.267-.06h.513c.03.06.03.362-.06.392zM105.716 176.711s-1.116-.181-2.594-.482c-1.478-.302-3.288-.785-4.676-1.207-1.388-.423-3.137-1.056-4.555-1.569a381.354 381.354 0 00-2.474-.905c-.15-.061-.03-.393.12-.332 0 0 1.087.302 2.535.754 1.418.453 3.197.996 4.585 1.418 1.388.422 3.138.996 4.586 1.358a153.4 153.4 0 002.534.664c.151.03.09.331-.061.301z"
      fill="#172845"
    />
    <path d="M103.704 31.86a3.98 3.98 0 100-7.96 3.98 3.98 0 000 7.96z" fill="url(#prefix__paint0_radial_2251_27739)" />
    <path
      d="M103.843 27.175l.212.352.422.106c.106.035.176.176.071.282l-.282.317.035.422c0 .141-.106.212-.246.176l-.388-.176-.387.176c-.106.07-.247-.035-.247-.176l.035-.422-.281-.317c-.071-.106-.036-.247.07-.282l.423-.106.211-.352c.141-.106.282-.106.352 0z"
      fill="#E7AD80"
    />
    <path
      d="M103.843 27.175l.212.352.422.106c.106.035.176.176.071.282l-.282.317.035.422c0 .141-.106.212-.246.176l-.388-.176-.387.176c-.106.07-.247-.035-.247-.176l.035-.422-.281-.317c-.071-.106-.036-.247.07-.282l.423-.106.211-.352c.141-.106.282-.106.352 0z"
      fill="url(#prefix__paint1_radial_2251_27739)"
    />
    <path
      d="M99.381 41.17l.106.177.211.035c.07 0 .07.106.036.141l-.141.141.035.211c0 .07-.07.106-.106.07l-.211-.105-.211.106c-.07.035-.106-.035-.106-.07l.035-.212-.14-.14c-.036-.036-.036-.107.035-.142l.21-.035.107-.176c.035-.07.105-.07.14 0z"
      fill="url(#prefix__paint2_radial_2251_27739)"
    />
    <path d="M138.752 64.936a2.008 2.008 0 10-.001-4.015 2.008 2.008 0 00.001 4.015z" fill="url(#prefix__paint3_radial_2251_27739)" />
    <path
      d="M138.827 62.576l.105.176.212.036c.07 0 .07.105.035.14l-.141.141.035.212c0 .07-.07.105-.105.07l-.212-.105-.211.105c-.07.035-.106-.035-.106-.07l.036-.212-.141-.14c-.036-.036-.036-.106.035-.141l.211-.036.106-.176c.035-.035.106-.035.141 0z"
      fill="#E7AD80"
    />
    <path
      d="M138.827 62.576l.105.176.212.036c.07 0 .07.105.035.14l-.141.141.035.212c0 .07-.07.105-.105.07l-.212-.105-.211.105c-.07.035-.106-.035-.106-.07l.036-.212-.141-.14c-.036-.036-.036-.106.035-.141l.211-.036.106-.176c.035-.035.106-.035.141 0z"
      fill="url(#prefix__paint4_radial_2251_27739)"
    />
    <path
      d="M122.615 81.038c19.468 0 35.251-15.79 35.251-35.266 0-19.477-15.783-35.266-35.251-35.266-19.469 0-35.252 15.79-35.252 35.266 0 19.477 15.783 35.266 35.252 35.266z"
      fill="url(#prefix__paint5_radial_2251_27739)"
    />
    <path
      d="M126.422 67.707c.163 1.671-.968 3.018-4.038 3.018-.076 0-.152-.003-.227-.008-3.102-.223-3.502-4.669-.528-5.577l.542-.165c1.8-.55 3.693.519 4.153 2.344l.098.388z"
      fill="url(#prefix__paint6_linear_2251_27739)"
    />
    <path
      d="M38.774 175.511c-.623-2.838-10.036-10.253-12.785-9.853-2.748.4 2.742 9.199 5.549 10.572 2.807 1.373 7.236-.719 7.236-.719zM103.934 68.538c1.627-1 4.931-5.975 6.555-11.337 1.624-5.362 1.074-11.188-1.168-9.697-2.243 1.492-6.71 7.503-7.847 11.2-1.137 3.697-2.633 12.397 2.46 9.834z"
      fill="#172845"
    />
    <path
      d="M96 65.332c6.754-3.617 13.352-9.208 13.87-9.554.519-.346 8.558-.693 10.114-.995 1.556-.302 5.878-11.214 0-10.514-5.878.7-11.366 3.488-18.253 6.814-6.886 3.327-14.828 19.121-5.73 14.249z"
      fill="#172845"
    />
    <path
      d="M119.989 44.269c-3.287.391-6.453 1.437-9.809 2.863-.556.763-.996 1.611-1.356 2.481-.915 2.215-1.375 4.592-1.773 6.945-.089.527-.155 1.06-.211 1.594 1.702-1.303 2.833-2.239 3.035-2.374.519-.346 8.558-.693 10.114-.995 1.556-.302 5.878-11.214 0-10.514z"
      fill="url(#prefix__paint7_linear_2251_27739)"
    />
    <path
      d="M124.91 22.512c-3.989-.695-7.449.259-7.68 1.923-.019.141-.006.282.012.428 1.096 9.014 2.789 26.478-5.803 41.713 3.234.763 14.346 2.685 14.346 2.685s-.755-10.815 1.085-24.877c1.315-10.043 3.202-14.632 4.174-16.435.356-.282.578-.617.631-.998.231-1.665-2.777-3.744-6.765-4.439z"
      fill="url(#prefix__paint8_linear_2251_27739)"
    />
    <path
      d="M112.289 66.766c3.985.85 13.492 2.495 13.492 2.495s-.195-2.804-.145-7.411a66.815 66.815 0 00-5.276-.243c-2.037-.023-4.257.019-6.184.79-.7 1.425-1.306 2.893-1.887 4.37z"
      fill="url(#prefix__paint9_linear_2251_27739)"
    />
    <path
      d="M125.772 69.46c-.231 1.664-3.653 2.45-7.641 1.756-3.989-.695-7.035-2.607-6.804-4.272.231-1.665 3.652-2.45 7.641-1.756 3.988.694 7.035 2.607 6.804 4.272z"
      fill="url(#prefix__paint10_linear_2251_27739)"
    />
    <path
      d="M125.771 69.46c.175-1.258-1.522-2.657-4.081-3.566-.038.791-.062 1.862-.019 3.073l-.005-.012c-1.09 1.028-2.722.446-4.3-.002l.472-2.137c-1.474-.228-2.889-.09-3.272.49l-.067.132c-.166.308 1.442 4.643 10.041 3.386.708-.338 1.153-.801 1.231-1.365z"
      fill="url(#prefix__paint11_linear_2251_27739)"
    />
    <path
      d="M117.839 66.816l-.472 2.137c1.578.448 3.21 1.03 4.3.002-.349-1.126-2.126-1.876-3.828-2.139z"
      fill="url(#prefix__paint12_linear_2251_27739)"
    />
    <path d="M114.564 67.306z" fill="url(#prefix__paint13_linear_2251_27739)" />
    <path d="M121.669 68.953l-.002.002.004.012a37.718 37.718 0 01.019-3.073h-.001a36.864 36.864 0 00-.02 3.059z" fill="#F0E6DA" />
    <path
      d="M121.669 68.953l-.002.002.004.012a37.718 37.718 0 01.019-3.073h-.001a36.864 36.864 0 00-.02 3.059z"
      fill="url(#prefix__paint14_linear_2251_27739)"
    />
    <path
      d="M121.669 68.953l-.002.002.004.012a37.718 37.718 0 01.019-3.073h-.001a36.864 36.864 0 00-.02 3.059z"
      fill="url(#prefix__paint15_linear_2251_27739)"
    />
    <path d="M114.566 67.306c.383-.58 1.799-.717 3.272-.49l.001-.006c-1.473-.225-2.89-.084-3.273.496z" fill="#F0E6DA" />
    <path
      d="M114.566 67.306c.383-.58 1.799-.717 3.272-.49l.001-.006c-1.473-.225-2.89-.084-3.273.496z"
      fill="url(#prefix__paint16_linear_2251_27739)"
    />
    <path
      d="M114.566 67.306c.383-.58 1.799-.717 3.272-.49l.001-.006c-1.473-.225-2.89-.084-3.273.496z"
      fill="url(#prefix__paint17_linear_2251_27739)"
    />
    <path d="M117.839 66.81l-.001.007c1.702.262 3.48 1.013 3.828 2.138l.003-.002c-.339-1.132-2.122-1.883-3.83-2.143z" fill="#F0E6DA" />
    <path
      d="M117.839 66.81l-.001.007c1.702.262 3.48 1.013 3.828 2.138l.003-.002c-.339-1.132-2.122-1.883-3.83-2.143z"
      fill="url(#prefix__paint18_linear_2251_27739)"
    />
    <path
      d="M117.839 66.81l-.001.007c1.702.262 3.48 1.013 3.828 2.138l.003-.002c-.339-1.132-2.122-1.883-3.83-2.143z"
      fill="url(#prefix__paint19_linear_2251_27739)"
    />
    <path
      d="M117.838 66.81c1.707.26 3.49 1.011 3.829 2.143a36.873 36.873 0 01.02-3.06 16.798 16.798 0 00-2.721-.706c-1.317-.229-2.571-.296-3.67-.224l-.798 2.475a.624.624 0 01.067-.132c.382-.58 1.799-.72 3.273-.496z"
      fill="url(#prefix__paint20_linear_2251_27739)"
    />
    <path
      d="M120.004 45.613c-1.256 7.445-4.382 15.489-5.869 18.38 3.878-1.17 10.679.442 12.287 3.714-1.236-13.84 1.217-31.016 5.706-41.16-1.225-4.506-8.328-5.746-12.128-4.961.613 3.672 1.584 14.665.004 24.027z"
      fill="url(#prefix__paint21_linear_2251_27739)"
    />
    <path
      d="M127.803 41.535c2.917 1.67 2.121 4.246-1.197 5.185-2.018.57-2.637.402-2.592-.403.045-.804.938-1.479 1.832-2.08.894-.602 1.287-.78 1.287-.78l.67-1.922z"
      fill="url(#prefix__paint22_linear_2251_27739)"
    />
    <path
      d="M126.873 48.56c.47.609 1.362 2.204.406 3.654-.957 1.45-2.407 2.408-3.19 1.915-.783-.493.638-2.437 1.247-3.133.609-.697.915-1.799.915-1.799l.622-.638z"
      fill="url(#prefix__paint23_linear_2251_27739)"
    />
    <path
      d="M127.893 46.381c2.316 2.436 1.122 4.144-2.378 4.866-2.053.423-2.666-.027-2.493-.814.173-.787 1.182-1.122 2.161-1.572.979-.45 1.517-.83 1.517-.83l1.193-1.65z"
      fill="url(#prefix__paint24_linear_2251_27739)"
    />
    <path
      d="M127.525 44.295c2.51 2.237 1.461 4.038-1.968 5.046-2.011.591-2.659.194-2.552-.605.108-.799 1.086-1.216 2.024-1.745.939-.53 1.444-.953 1.444-.953l1.052-1.743z"
      fill="url(#prefix__paint25_linear_2251_27739)"
    />
    <path
      d="M73.962 30.906c2.962-.178 5.446 2.981 9.088 8.95 3.368 5.518 8.019 10.867 9.749 11.934 1.697 1.047 16.52-4.286 16.52-4.286-4.427 2.49-10.737 23.895-5.152 20.902-5.57 3.141-7.097 4.145-10.83 3.138-3.732-1.008-11.91-9.582-15.584-17.998-3.673-8.416-9.656-22.403-3.791-22.64z"
      fill="url(#prefix__paint26_linear_2251_27739)"
    />
    <path
      d="M81.63 37.588c-2.903-4.494-5.107-6.836-7.668-6.683-5.865.237.118 14.225 3.791 22.641 1.156 2.649 3.477 6.642 5.756 9.376.769-1.82 4.181-11.132-1.879-25.334z"
      fill="url(#prefix__paint27_linear_2251_27739)"
    />
    <path
      d="M69.254 29.117c1.753-.627 5.212-.983 8.16 1.1 5.312 3.752 4.542 10.452 3.85 18.077-.693 7.625-12.01-19.177-12.01-19.177z"
      fill="url(#prefix__paint28_linear_2251_27739)"
    />
    <path
      d="M109.318 47.504c3.938-2.258 9.054-4.795 10.534-4.969 1.48-.174 3.972 1.203 4.704 2.191.392.53.263 2.046.157 2.89-.203 1.632-1.731 1.826-2.343-.2-.441-1.46-1.983-1.036-2.861.591-.697 1.29-1.49 2.584-4 3.421"
      fill="url(#prefix__paint29_linear_2251_27739)"
    />
    <path
      d="M118.385 62.964c-.633 3.88-.42 9.795-.42 9.795s-1.196-1.017-2.022-2.055c-1.23.981-1.923 1.69-1.923 1.69s.018-5.974 1.17-10.292l3.195.862z"
      fill="url(#prefix__paint30_linear_2251_27739)"
    />
    <path
      d="M119.428 58.704l.44 1.097.963.685-.224 1.16.44 1.097-.815.856-.223 1.16-1.148.28-.815.855-1.116-.386-1.148.28-.73-.93-1.117-.385-.112-1.177-.731-.928.541-1.051-.113-1.176 1.023-.592.54-1.05 1.18.055 1.023-.59.962.684 1.18.056z"
      fill="url(#prefix__paint31_linear_2251_27739)"
    />
    <path d="M117.051 63.807a1.781 1.781 0 100-3.562 1.781 1.781 0 000 3.562z" fill="url(#prefix__paint32_linear_2251_27739)" />
    <path
      d="M61.498 76.588c-7.38.811-18.734 2.57-20.491-3.922-1.757-6.49-1.216-27.538-.676-35.27.54-7.73 8.239-11.247 17.839-11.247 9.6 0 10.546.574 10.681 4.75.136 4.175 4.216 44.202-7.353 45.689z"
      fill="url(#prefix__paint33_linear_2251_27739)"
    />
    <path
      d="M40.03 43.356c.215-4.568 1.703-8.474 4.84-9.65 3.139-1.178 13.494-1.414 13.494-1.414l5.783-2.746s-15.59.194-19.825 1.352c-4.236 1.16-4.13 6.728-4.293 12.458z"
      fill="#172845"
    />
    <path
      d="M42.643 44.484c-4.839-.023-6.16 1.4-6.616 4.482-.456 3.08-.114 15.535.799 18.493.912 2.958 8.44 3.949 9.809-.597 1.368-4.546.875-14.455.608-17.203-.266-2.747-1.919-5.161-4.6-5.175z"
      fill="url(#prefix__paint34_linear_2251_27739)"
    />
    <path
      d="M96.42 156.512c.272 2.093-1.204 3.747-3.034 5.164-1.83 1.418-9.913 4.821-13.101 5.707-3.188.886-10.603 2.679-10.603.085 0-4.489 7.947-14.296 15.263-17.307 7.316-3.012 10.67 1.306 11.474 6.351z"
      fill="url(#prefix__paint35_linear_2251_27739)"
    />
    <path
      d="M93.852 150.26c.668 10.894.572 21.179 1.373 30.109.801 8.93-9.612 12.708-12.702 1.03-3.09-11.677-4.349-21.98-5.035-28.62-.687-6.64 15.887-10.298 16.364-2.519z"
      fill="#172845"
    />
    <path
      d="M93.852 150.26c.668 10.894.572 21.179 1.373 30.109.801 8.93-9.612 12.708-12.702 1.03-3.09-11.677-4.349-21.98-5.035-28.62-.687-6.64 15.887-10.298 16.364-2.519z"
      fill="url(#prefix__paint36_linear_2251_27739)"
    />
    <path
      d="M94.322 160.83c-.441.634-.795 1.335-1.115 2.031-.404.878-.733 1.784-1.08 2.685-.47 1.217-1.625 5.954-1.92 7.251-.599 2.629-1.397 5.588-1.764 8.258a318.08 318.08 0 00-.916 7.307c3.901 1.516 8.224-2.12 7.697-7.993-.537-5.979-.672-12.568-.903-19.539z"
      fill="url(#prefix__paint37_linear_2251_27739)"
    />
    <path
      d="M39.995 110.992c.942 2.8 11.255-1.237 12.992-4.159 1.736-2.922 1.324-3.322.996-4.931-.328-1.609-4.064-4.246-8.525-2.567-4.462 1.68-6.644 6.878-5.463 11.657z"
      fill="url(#prefix__paint38_linear_2251_27739)"
    />
    <path
      d="M54.996 51.17c.118 4.633 1.282 11.472 4.357 14.1 3 2.564 12.11 1.544 15.113.312 5.943-2.44 5.948-3.793 6.765-5.394.817-1.602 3.007-10.114.985-17.867-2.022-7.754-6.22-11.423-10.716-12.105-4.212-.639-8.18-1.2-13.114.005-4.762 3.243-3.505 16.412-3.39 20.948z"
      fill="url(#prefix__paint39_linear_2251_27739)"
    />
    <path
      d="M63.452 57.763c.08 1.18.245 2.355.497 3.51.463-.164.939-.295 1.419-.411.875-.212 1.761-.38 2.652-.51a35.518 35.518 0 014.892-.368c1.479-.01 2.947.097 4.42.21 1.217.092 2.442.205 3.63.504l.02.006c.079-.17.158-.342.247-.516.817-1.601 3.007-10.113.986-17.867-2.022-7.754-6.22-11.423-10.716-12.104-3.094-.47.938 4.5-2.373 4.784-.03.314-7.059-4.767-7.093-4.454-.2 1.796-.434 3.59-.514 5.397-.04.903-.041 1.809.032 2.71.036.442.09.882.171 1.318.07.374.137.769.309 1.112.516 1.03 1.787.838 2.552 1.553 1.17 1.093-1.25 13.375-1.13 15.126z"
      fill="url(#prefix__paint40_linear_2251_27739)"
    />
    <path
      d="M62.661 66.592c-2.75-.362-3.615-1.318-1.905-2.186 2.005-1.018 4.416-1.745 4.416-1.745l-2.511 3.93zM54 154.436c-6.748 8.575-13.662 16.188-19.005 23.386-5.343 7.198-14.728 3.496-10.166-7.688 5.091-12.482 9.94-18.735 13.845-24.148 3.905-5.413 20.146 2.326 15.327 8.45z"
      fill="#172845"
    />
    <path
      d="M54 154.436c-6.748 8.575-13.662 16.188-19.005 23.386-5.343 7.198-14.728 3.496-10.166-7.688 5.091-12.482 9.94-18.735 13.845-24.148 3.905-5.413 20.146 2.326 15.327 8.45z"
      fill="url(#prefix__paint41_linear_2251_27739)"
    />
    <path
      d="M93.6 87.187C91.382 79.38 85.996 70.1 79.066 62.474c-4.644-2.003-11.317-1.224-15.822.514a3.19 3.19 0 00-1.746 1.617C58.4 71.212 52.214 84.522 49.495 97.97c-2.84 14.052-2.991 28.339-2.991 28.339s-3.045 2.393-1.18 3.964c-6.283 5.696-8.311 14.431-11.943 18.893-3.633 4.462.263 11.663 5.396 16.647 4.049 3.933 9.623 4.665 11.096 3.093 1.473-1.571 13.514-26.847 17.343-33.918 1.092-2.018 2.406-5.692 3.76-10.006l-1.294 42.487c0-1.508 9.255-8.733 18.682-11.851 3.447-1.14 7.695-1.747 8.056.896-1.95-10.398 1.545-53.975-2.82-69.326z"
      fill="url(#prefix__paint42_linear_2251_27739)"
    />
    <path
      d="M47.922 138.151l.228-.569c.138-.356.322-.858.504-1.436.368-1.15.686-2.638.62-3.769-.03-.555-.144-1.206-.531-1.653-.374-.46-1.019-.617-1.592-.607-.579.004-1.097.135-1.457.238-.183.047-.326.098-.425.131l-.154.051c-.12.037-.225-.23-.11-.283l.153-.064c.1-.041.243-.104.43-.166.369-.132.898-.307 1.546-.351a3.073 3.073 0 011.036.097c.357.098.712.302.977.593.265.288.445.639.547.984.102.345.152.685.168 1 .066 1.267-.347 2.79-.788 3.944-.221.58-.44 1.077-.605 1.428-.165.351-.27.559-.27.559-.08.104-.31-.006-.277-.127zM50.745 123.67s-1.269.897-2.129 1.399c-.863.497-2.271 1.152-2.271 1.152-.05.021-.192-.229-.152-.263 0 0 1.268-.897 2.128-1.399.863-.497 2.271-1.152 2.271-1.152.061 0 .188.221.153.263z"
      fill="#172845"
    />
    <path
      d="M93.6 87.186C91.38 79.38 85.992 70.1 79.062 62.474c-2.772-1.195-6.266-1.4-9.591-1a270.602 270.602 0 00-7.011 18.51c-4.062 12.027-2.258 34.385-6.472 42.031-4.215 7.645-14.127 28.589-17.214 43.797 4.05 3.933 9.624 4.664 11.097 3.093 1.4-1.495 12.372-24.455 16.73-32.768 1.682-2.908 3.311-8 4.373-11.157 3.31-9.84 5.374-18.67 6.697-24.084 1.747-7.15 3.956-9.965 5.394-11.815 1.438-1.85-1.307 4.43-1.307 4.43 5.332 22.403.836 45.608 4.516 62.865.693-.273 1.39-.528 2.088-.759 3.447-1.14 7.694-1.748 8.056.895-1.95-10.397 1.544-53.974-2.82-69.326z"
      fill="url(#prefix__paint43_linear_2251_27739)"
    />
    <path
      d="M53.387 161.771c-.233-.012-.561-.057-.97-.106a18.857 18.857 0 01-3.297-.776c-1.285-.418-2.665-1.066-3.947-1.852a19.133 19.133 0 01-3.363-2.675 19.082 19.082 0 01-2.65-3.383c-.776-1.287-1.414-2.672-1.824-3.961a18.92 18.92 0 01-.752-3.304c-.049-.423-.093-.762-.101-.996l-.006-.079c-.102.044-.202.091-.303.137.004.237.036.567.07.978.09.862.279 2.067.675 3.394.386 1.33 1.008 2.766 1.784 4.105a18.378 18.378 0 002.697 3.517 18.352 18.352 0 003.497 2.722c1.332.786 2.763 1.419 4.09 1.814 1.324.405 2.527.603 3.388.698.422.039.759.073.997.078.008-.103.011-.207.015-.311zM94.84 171.377c-6.93.871-10.433 2.792-14.314 5.089a1.407 1.407 0 00-.624 1.635l4.505 14.166 12.803-3.26-.79-16.24a1.404 1.404 0 00-1.58-1.39z"
      fill="#172845"
    />
    <path
      d="M94.84 171.377c-6.93.871-10.433 2.792-14.314 5.089a1.407 1.407 0 00-.624 1.635l4.505 14.166 12.803-3.26-.79-16.24a1.404 1.404 0 00-1.58-1.39z"
      fill="url(#prefix__paint44_linear_2251_27739)"
    />
    <path
      d="M96.42 172.767a1.404 1.404 0 00-1.58-1.39c-1.69.212-3.173.488-4.51.816-.06.184-.105.393-.123.604.532.018 4.238-.457 4.768-.458.625 0 1.18.086 1.448.477l-.003-.049z"
      fill="url(#prefix__paint45_linear_2251_27739)"
    />
    <path
      d="M83.6 189.395c4.691-1.543 9.002-5.692 13.326-6.687.998-.229 1.961.517 2.005 1.542.139 3.236.758 8.456 3.446 11.145 2.074 2.075 5.902 3.657 8.507 4.559a4.064 4.064 0 012.729 3.844v.772a.43.43 0 01-.429.43h-29.17c-.714-3.151-2.2-7.523-.375-9.919l-1.043-3.793a1.555 1.555 0 011.004-1.893z"
      fill="url(#prefix__paint46_linear_2251_27739)"
    />
    <path
      d="M83.6 189.395c4.691-1.543 9.002-5.692 13.326-6.687.998-.229 1.961.517 2.005 1.542.139 3.236.758 8.456 3.446 11.145 2.074 2.075 5.902 3.657 8.507 4.559a4.064 4.064 0 012.729 3.844v.772a.43.43 0 01-.429.43h-29.17c-.714-3.151-2.2-7.523-.375-9.919l-1.043-3.793a1.555 1.555 0 011.004-1.893z"
      fill="url(#prefix__paint47_linear_2251_27739)"
    />
    <path
      d="M100.899 193.393c.227 1.295.564 2.6 1.284 3.717.86 1.333 2.224 2.202 3.689 2.749 1.664.621 3.439.793 5.164 1.166.678.147 1.326.363 1.958.618a4.043 4.043 0 00-2.112-1.689c-2.605-.902-6.433-2.484-8.507-4.559-.592-.592-1.084-1.308-1.492-2.098l.016.096z"
      fill="url(#prefix__paint48_linear_2251_27739)"
    />
    <path
      d="M90.559 180.044l2.836-1.776c.136-.083.121-.077.148-.096l.056-.041a.977.977 0 00.074-.059l-.144.028-.049.012-.018.005-.19.028a55.66 55.66 0 00-2.977.539c-1.807.364-4.085.97-5.88 1.58a50.3 50.3 0 00-2.232.816l-.885.359c-.185.073-.297-.192-.124-.278 0 0 .326-.157.875-.402a43.884 43.884 0 012.217-.913c1.788-.684 4.078-1.367 5.91-1.739a39.564 39.564 0 013.023-.499l.582-.072.723-.077.71-.074.347-.035.17-.018.086-.009.042-.004.021-.002c.009-.001.016-.002.004.004l-1.205.714-1.056.615-2.909 1.656c-.184.074-.312-.146-.155-.262z"
      fill="#172845"
    />
    <path
      d="M25.227 166.07l-6.762 12.231 11.163 7.066 8.945-9.078a.806.806 0 00-.465-1.364c-4.623-.674-9.794-4.688-11.426-8.758-.254-.634-1.124-.694-1.454-.097z"
      fill="url(#prefix__paint49_linear_2251_27739)"
    />
    <path
      d="M19.801 176.387c5.239 6.585 8.19 4.235 12.96 5.958a1.3 1.3 0 01.537 2.081c-2.119 2.414-3.942 4.929-4.05 8.755-.081 2.936.351 4.643 2.909 5.681 1.62.657 2.94 3.276 2.848 5.023l-.06 1.115H19.58c-4.44 0-3.54-9.077-5.672-11.699-2.079-2.556-3.66-4.416-3.713-5.666 1-3.388 2.703-7.64 5.697-7.959l1.91-3.154a1.222 1.222 0 011.999-.135z"
      fill="url(#prefix__paint50_linear_2251_27739)"
    />
    <path
      d="M28.006 187.08c-.563-.297-1.246-.753-1.727-1.207a8.496 8.496 0 01-.576-.598l-.21-.261c-.047-.049-.286.103-.249.167l.186.299c.123.182.304.432.535.698a6.662 6.662 0 001.768 1.413 6.67 6.67 0 002.16.678c.223.028.427.042.605.049.06-.118.125-.233.19-.349a8.188 8.188 0 01-.718-.13c-.645-.146-1.404-.458-1.964-.759zM24.426 188.942a9.09 9.09 0 002.581 1.138 9.078 9.078 0 002.692.223c.035-.117.068-.235.106-.35-.19-.012-.453-.032-.75-.067a15.283 15.283 0 01-1.907-.368c-.57-.14-1.29-.352-1.856-.576-.282-.112-.527-.22-.701-.3l-.277-.133c-.058-.022-.206.219-.152.258l.264.175zM29.179 192.251s-.347.073-.813.13a9.704 9.704 0 01-1.51.074 9.622 9.622 0 01-1.496-.21c-.459-.099-.798-.203-.798-.203-.046-.016.01-.293.057-.294 0 0 .346.035.802.064.456.031 1.021.046 1.462.065.44.021 1.005.057 1.461.068.457.012.805.009.805.009.05.025.075.274.03.297zM33.482 177.313l-.69-.13c-.213-.047-.464-.124-.75-.2-.286-.074-.589-.203-.92-.317-1.308-.5-2.79-1.467-3.776-2.419-.99-.945-2.018-2.387-2.571-3.675-.128-.326-.269-.623-.355-.906-.088-.283-.175-.531-.23-.742l-.158-.684c-.03-.143.247-.197.29-.067l.195.652c.066.202.165.438.264.705.098.268.25.548.388.854.596 1.213 1.632 2.545 2.578 3.445.937.908 2.31 1.889 3.546 2.435.312.125.598.266.87.353.271.088.51.177.714.234l.66.168c.131.059.088.306-.055.294zM21.875 176.342l.145-.189.052-.068.2.089c.01.006.08.144.26.308.174.164.472.346.838.401.091.011.185.019.28.012a.976.976 0 00.263-.042c.069-.031.057-.037.061-.057a.5.5 0 00-.041-.201c-.167-.42-.34-.877-.471-1.269a24.346 24.346 0 01-.748-2.819 14.289 14.289 0 01-.237-1.582c-.007-.095.273-.127.296-.04 0 0 .12.662.366 1.52.239.859.591 1.913.871 2.737l.433 1.286c.036.13.083.286.034.492a.545.545 0 01-.168.274.639.639 0 01-.247.132 1.41 1.41 0 01-.409.042 1.825 1.825 0 01-.367-.045 1.943 1.943 0 01-1.009-.594c-.2-.223-.264-.403-.271-.413l.251.021-.146.188c-.08.055-.277-.099-.236-.183zM31.829 198.783l-.376-.149a10.551 10.551 0 00-.96-.294c-.775-.198-1.764-.288-2.535-.276-.771.005-1.758.116-2.529.331-.385.105-.717.224-.953.314l-.372.157c-.079.03-.212-.224-.14-.27l.368-.204c.235-.118.568-.275.963-.421a8.453 8.453 0 012.656-.496c.825-.01 1.874.16 2.667.439.398.137.735.287.972.4l.372.196c.066.064-.05.29-.133.273zM78.99 76.89c.04.003.082.02.142.017l.19-.022.147-.017a.831.831 0 00.12-.028c.13 1.116.223 2.105.286 2.904.062.666.09 1.201.119 1.569l.04.569c.034.428.322.43.303-.017l-.028-.57c-.02-.37-.038-.907-.087-1.577a78.748 78.748 0 00-.505-5.334 56.9 56.9 0 00-1.302-6.805 84.886 84.886 0 00-.956-3.403l-.495-1.618-.241-.78a18.206 18.206 0 00-.017-.053 16.59 16.59 0 00-.658-.133l.861 2.751c.337 1.096.677 2.228.982 3.373a58.911 58.911 0 011.386 6.73c.108.743.201 1.454.281 2.125a.916.916 0 00-.12-.005l-.147.014-.165.015c-.01.002-.043-.007-.085-.014l-.123-.024a3.83 3.83 0 01-1.382-.584 3.848 3.848 0 01-1.61-2.36l-.131-.704-.276-1.527-.294-1.623c-.107-.552-.23-1.112-.347-1.68l-.729-3.469-.699-3.3a21.474 21.474 0 00-.59-.017l.76 3.432.773 3.46c.126.566.257 1.125.372 1.674l.318 1.607.3 1.513.148.726a4.21 4.21 0 001.813 2.558c.587.385 1.14.53 1.513.603l.134.024zM53.104 97.39l.882 4.512s3.58 9.678 4.086 11.363c-.223 3.324-7.252 5.445-10.662 5.024-2.316-3.86-1.048-13.115-1.048-13.115l-.901-4.298 7.643-3.487z"
      fill="#172845"
    />
    <path
      d="M54.263 116.068c.346 3.083-.658 4.553-2.557 5.705-1.898 1.151-2.45 2.58-.674 2.3 1.776-.281 4.02-1.029 4.954-2.058.934-1.028 2.617-7.387 2.082-8.75l-.52-1.545"
      fill="#172845"
    />
    <path
      d="M55.333 115.468l-1.031 4.488a3.154 3.154 0 01-1.055 1.718c-.801.669-1.99 1.654-2.604 2.138-.98.772-1.632-.03-1.098-1.158.534-1.128 1.306-2.099 1.662-2.861.356-.762.683-2.751.683-2.751"
      fill="#172845"
    />
    <path d="M46.795 116.91c.438 2.21 1.328 5.417 1.773 6.308.446.891 1.395.327 1.514-.356s.375-2.079.137-5.464" fill="#172845" />
    <path
      d="M52.99 116.716c-.03 1.395-.37 3.385-.644 4.275-.275.891-1.237 2.987-2.388 3.127-1.152.14-.5-2.235-.321-3.824.178-1.589.088-2.569.088-2.569"
      fill="#172845"
    />
    <path
      d="M53.985 101.903l-.053-.276c-.887-.066-1.766.359-2.498.851-1.914 1.287-3.314 3.181-4.84 4.874-.16.176-.322.348-.485.519-.195 3.04-.217 7.888 1.3 10.419 3.411.421 10.44-1.7 10.663-5.024-.506-1.686-4.087-11.363-4.087-11.363z"
      fill="url(#prefix__paint51_linear_2251_27739)"
    />
    <path
      d="M50.336 107.454c1.186 1.551 2.631 2.862 4.433 3.654.898.395 1.83.555 2.775.596-1.142-3.263-3.561-9.802-3.561-9.802l-.054-.275c-.886-.066-1.766.359-2.497.851-1.046.703-1.936 1.589-2.78 2.522.536.835 1.08 1.665 1.684 2.454z"
      fill="url(#prefix__paint52_linear_2251_27739)"
    />
    <path
      d="M54.26 116.068c.347 3.082-.657 4.553-2.556 5.705-1.898 1.151-2.45 2.58-.674 2.3 1.776-.281 4.02-1.029 4.954-2.058.934-1.028 2.617-7.387 2.082-8.75l-.52-1.546"
      fill="url(#prefix__paint53_linear_2251_27739)"
    />
    <path
      d="M55.333 115.468l-1.031 4.488a3.154 3.154 0 01-1.055 1.718c-.801.669-1.99 1.654-2.604 2.138-.98.772-1.632-.03-1.098-1.158.534-1.128 1.306-2.099 1.662-2.861.356-.762.683-2.751.683-2.751"
      fill="url(#prefix__paint54_linear_2251_27739)"
    />
    <path
      d="M46.791 116.911c.438 2.21 1.328 5.417 1.774 6.308.445.89 1.395.326 1.513-.357.119-.683.375-2.078.137-5.464"
      fill="url(#prefix__paint55_linear_2251_27739)"
    />
    <path
      d="M52.987 116.716c-.03 1.395-.37 3.385-.645 4.275-.275.891-1.236 2.988-2.388 3.127-1.152.14-.5-2.234-.321-3.824.178-1.589.089-2.569.089-2.569"
      fill="url(#prefix__paint56_linear_2251_27739)"
    />
    <path
      d="M52.025 60.11c8.416-9.497 13.256-16.011 13.666-23.799.303-5.744-2.55-8.023-5.375-8.023s-6.981 3.162-7.886 10.454c-.715 5.76-4.092 25.529-.405 21.368z"
      fill="url(#prefix__paint57_linear_2251_27739)"
    />
    <path
      d="M59.286 31.278c-.675-.995-1.98-1.327-3.078-.84-2.085.926-4.152 3.185-6.767 7.836-3.228 5.74-14.466 27.987-15.183 38.511-.718 10.526 3.228 27.03 5.738 34.206-1.374-4.391 12.314-13.395 13.988-9.089-3.587-17.223-3.81-29.708-.65-40.15s5.432-16.422 6.388-20.967c.747-3.547.975-7.424-.436-9.507z"
      fill="url(#prefix__paint58_linear_2251_27739)"
    />
    <path
      d="M59.285 31.278c-.674-.995-3.138 4.279-5.754 8.93-3.228 5.74-14.04 26.697-14.757 37.222-.717 10.525-1.288 26.386 1.222 33.562-1.374-4.392 12.314-13.395 13.988-9.09-3.587-17.222-3.81-29.708-.65-40.15 3.16-10.441 5.432-16.421 6.388-20.966.747-3.548.975-7.425-.437-9.508z"
      fill="url(#prefix__paint59_linear_2251_27739)"
    />
    <path
      d="M62.481 22.599c.38 1.448 5.951 1.398 13.867-.682 7.916-2.08 12.418-5.078 12.05-6.529-.268-1.056-5.51-.793-13.426 1.287s-12.87 4.476-12.49 5.924z"
      fill="url(#prefix__paint60_linear_2251_27739)"
    />
    <path
      d="M79.629 16.323c3.391 2.893 4.626 6.77 3.418 9.412 2.557 3.778.409 7.27-3.982 7.704-5.263.52-4.977-1.993-4.977-1.993-1.77-1.833-.382-6.01 1.609-7.735-1.066-1.714.198-4.868.198-4.868l3.734-2.52z"
      fill="url(#prefix__paint61_linear_2251_27739)"
    />
    <path
      d="M64.793 29.513c1.845-.226 3.441 1.266 6.65 4.21 2.293 2.102 4.888 2.452 3.874-.337 1.144-4.096 2.219-7.82 2.219-7.82s2.395-.177 3.24-.57c.846-.394 1.987-7.8.724-12.916-1.262-5.115-15.047 6.105-15.047 6.105s3.429 6.165-1.66 11.328z"
      fill="url(#prefix__paint62_linear_2251_27739)"
    />
    <path
      d="M76.884 27.838c-2.997-.56-4.024-3.14-4.822-3.306-1.981-.415-1.494 1.819-3.26.832-.464-.259-.915-.54-1.359-.832-.282 1.609-1.037 3.345-2.65 4.981 1.845-.225 3.441 1.266 6.65 4.21 2.293 2.103 4.888 2.452 3.875-.337a963.79 963.79 0 011.566-5.548z"
      fill="url(#prefix__paint63_linear_2251_27739)"
    />
    <path
      d="M81.5 12.08c-1.262-5.115-15.047 6.105-15.047 6.105s.893 1.61 1.09 3.871c.401.193.802.385 1.204.575 2.8 1.32 5.704 2.533 8.788 2.94 1.425 0 2.396-.182 3.241-.576.846-.393 1.987-7.8.725-12.915z"
      fill="url(#prefix__paint64_linear_2251_27739)"
    />
    <path
      d="M72.56 15.095c2.556 3.654 2.652 9.136.819 11.39 2.894 3.709-.142 10.12-4.252 8.517-3.424-1.337-1.806-5.334-5.548-5.489-1.252-2.22-.312-4.824 2.049-5.993-.6-1.928 1.415-4.662 1.415-4.662l5.518-3.763z"
      fill="url(#prefix__paint65_linear_2251_27739)"
    />
    <path
      d="M70.616 29.513l.484-2.342-1.21.436s1.593-1.604 2.214-4.221c.598-2.52-.605-5.767-1.01-7.29l-4.051 2.762s-2.016 2.734-1.415 4.662c-2.361 1.169-3.3 3.773-2.049 5.993 2.002.083 2.47 1.265 2.996 2.552 1.328 1.55 3.556-.21 4.04-2.552z"
      fill="url(#prefix__paint66_linear_2251_27739)"
    />
    <path
      d="M74.972 16.675c7.222-1.898 12.1-2.297 13.426-1.287-1.232-1.87-6.296-4.485-8.234-5.004-7.776 1.028-12.225 4.297-14.43 6.478-2.205 2.182-3.181 5.273-3.181 5.273h.001c.762-1.536 5.276-3.584 12.418-5.46z"
      fill="#172845"
    />
    <path
      d="M82.065 11.108c-1.469-4.442-3.607-6.063-6.162-6.455-2.555-.391-8.147 2.686-9.523 6.091-.924 2.286-.615 6.733-.615 6.733s13.178-3.555 16.3-6.37z"
      fill="#172845"
    />
    <path
      d="M82.064 11.108c-1.469-4.442-3.607-6.063-6.162-6.455-2.555-.392-8.147 2.685-9.523 6.09-.714 1.767-.692 4.82-.645 6.12-2.205 2.18-3.181 5.273-3.181 5.273h.001c.761-1.537 5.276-3.585 12.418-5.461 7.222-1.898 12.1-2.297 13.426-1.287-.928-1.41-4.031-3.24-6.334-4.28z"
      fill="url(#prefix__paint67_linear_2251_27739)"
    />
    <path
      d="M83.595 202.847s9.036-.14 14.853-.143c5.818.003 14.854.143 14.854.143.312.007.301.294 0 .304 0 0-9.036.14-14.854.142-5.817-.002-14.853-.142-14.853-.142-.309-.03-.304-.285 0-.304zM11.03 185.994l.046.104c.024.07.091.163.165.287.038.062.078.132.127.205l.176.234c.119.172.285.35.457.556.709.811 1.853 1.835 2.948 3.219.54.693 1.072 1.479 1.463 2.369.403.887.63 1.875.828 2.814l.587 2.806c.202.905.415 1.777.728 2.525.155.372.349.741.61 1.041.264.298.6.512 1 .567.1.02.2.018.307.025l.355.002.715.004 1.446.009 5.62.049 6.099.07c.363.007.35.294 0 .304l-6.099.07-5.62.049-1.446.009-.715.004-.355.002c-.128-.006-.262-.004-.393-.029a2.086 2.086 0 01-.755-.257 2.461 2.461 0 01-.595-.489c-.331-.377-.546-.796-.717-1.202-.339-.816-.55-1.711-.747-2.631-.194-.921-.366-1.871-.556-2.818-.187-.956-.384-1.876-.75-2.724-.357-.851-.851-1.615-1.362-2.299-1.035-1.365-2.151-2.414-2.858-3.261-.174-.217-.338-.404-.46-.588l-.178-.25c-.05-.079-.092-.156-.132-.223-.075-.136-.143-.235-.17-.315a27.856 27.856 0 01-.048-.116c-.122-.363.13-.418.279-.122zM69.892 157.183l.04-.11c.031-.069.082-.165.151-.285.143-.236.38-.547.701-.909.64-.724 1.63-1.632 2.82-2.584a45.738 45.738 0 014.019-2.851 48.128 48.128 0 014.237-2.398 42.397 42.397 0 014.477-1.922c1.594-.583 3.253-1.064 4.778-1.27.76-.106 1.49-.142 2.149-.088.657.052 1.248.215 1.689.479.219.135.394.292.529.446.128.161.22.312.277.442.06.13.093.234.11.306l.03.108c.058.34-.234.343-.295.071l-.029-.092a1.455 1.455 0 00-.101-.258 1.748 1.748 0 00-.241-.361 1.998 1.998 0 00-.456-.362c-.384-.216-.921-.355-1.541-.387a9.692 9.692 0 00-2.056.136c-1.476.235-3.088.737-4.655 1.339a47.939 47.939 0 00-4.402 1.941 55.597 55.597 0 00-4.214 2.331 48.47 48.47 0 00-4.032 2.741c-1.196.913-2.197 1.784-2.837 2.469a6.46 6.46 0 00-.69.841 3.28 3.28 0 00-.138.243l-.033.085c-.038.062-.056.098-.092.129a.172.172 0 01-.107.047c-.034 0-.066-.02-.087-.068a.29.29 0 01-.001-.209zM99.333 190.366c-.435.095-.972.238-1.38.387-.408.15-.91.387-1.305.594a15.19 15.19 0 00-.684.382c-.037.027.083.288.127.275l2.064-.698 1.704-.671a18.496 18.496 0 01-.098-.358c-.12.023-.267.053-.428.089zM97.653 193.922c-.368.253-.635.459-.635.459-.033.032.117.277.16.259l1.966-.937 1.534-.824a12.788 12.788 0 01-.159-.356 17.54 17.54 0 00-.316.107c-.42.146-.937.352-1.325.547a12 12 0 00-1.225.745zM95.445 188.907l.735-.154 1.34-.251 1.335-.285.456-.088c-.02-.121-.039-.241-.056-.361a11 11 0 00-.453.008c-.436.015-.979.066-1.397.149a9.594 9.594 0 00-1.347.401c-.41.153-.709.292-.709.292-.038.023.052.296.096.289zM51.346 122.867s.195-.458.41-1.075c.22-.616.444-1.394.606-2.005.167-.61.366-1.395.487-2.038.124-.641.186-1.135.186-1.135.012-.243.299-.224.303.02 0 0 .008.507-.049 1.176a12.794 12.794 0 01-.358 2.131 12.787 12.787 0 01-.764 2.021c-.288.606-.55 1.04-.55 1.04-.151.239-.382.131-.271-.135zM49.654 122.973l.187-2.364.276-2.354c.02-.199.306-.19.304.004 0 0 .031.365.045.85.014.484.006 1.088-.04 1.558a13.536 13.536 0 01-.264 1.535c-.107.473-.209.825-.209.825-.079.196-.338.185-.299-.054zM52.278 123.259s.13-.07.329-.211a4.78 4.78 0 00.725-.643c.263-.284.518-.638.737-1.01.217-.374.396-.766.534-1.118.285-.703.54-1.656.696-2.443.159-.786.415-1.935.415-1.935.017-.191.301-.14.301.038 0 0-.186 1.155-.277 1.967-.088.811-.282 1.828-.587 2.589-.15.38-.363.798-.623 1.19-.262.39-.57.754-.884 1.037a4.797 4.797 0 01-.852.622c-.23.129-.379.189-.379.189-.212.072-.328-.156-.135-.272z"
      fill="#172845"
    />
    <path d="M140.544 58.085a1.685 1.685 0 10-.001-3.37 1.685 1.685 0 00.001 3.37z" fill="url(#prefix__paint68_radial_2251_27739)" />
    <path d="M102.163 34.683a1.686 1.686 0 10-.001-3.37 1.686 1.686 0 00.001 3.37z" fill="url(#prefix__paint69_radial_2251_27739)" />
    <path d="M113.651 29.335a1.685 1.685 0 100-3.37 1.685 1.685 0 000 3.37z" fill="url(#prefix__paint70_radial_2251_27739)" />
    <path d="M139.079 35.414a1.686 1.686 0 10-.001-3.37 1.686 1.686 0 00.001 3.37z" fill="url(#prefix__paint71_radial_2251_27739)" />
    <path
      d="M139.142 33.433l.089.148.177.03c.059 0 .059.088.03.118l-.119.118.03.178c0 .059-.059.088-.089.059l-.177-.09-.177.09c-.059.03-.089-.03-.089-.06l.03-.177-.119-.118c-.029-.03-.029-.089.03-.118l.177-.03.089-.148c.029-.059.089-.059.118 0z"
      fill="#E7AD80"
    />
    <path d="M138.906 47.136a3.34 3.34 0 003.339-3.341 3.34 3.34 0 10-3.339 3.341z" fill="url(#prefix__paint72_radial_2251_27739)" />
    <path
      d="M139.412 42.714l.177.296.354.089c.089.03.148.148.06.236l-.237.266.03.355c0 .118-.089.177-.207.148l-.325-.148-.325.148c-.089.06-.207-.03-.207-.148l.029-.355-.236-.266c-.059-.089-.03-.207.059-.236l.355-.089.177-.296c.118-.088.266-.088.296 0z"
      fill="#E7AD80"
    />
    <path
      d="M139.412 42.714l.177.296.354.089c.089.03.148.148.06.236l-.237.266.03.355c0 .118-.089.177-.207.148l-.325-.148-.325.148c-.089.06-.207-.03-.207-.148l.029-.355-.236-.266c-.059-.089-.03-.207.059-.236l.355-.089.177-.296c.118-.088.266-.088.296 0z"
      fill="url(#prefix__paint73_radial_2251_27739)"
    />
    <defs>
      <linearGradient id="prefix__paint6_linear_2251_27739" x1={121.892} y1={65.231} x2={126.186} y2={75.794} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint7_linear_2251_27739" x1={104.838} y1={55.476} x2={131.574} y2={43.712} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint8_linear_2251_27739" x1={140.252} y1={60.772} x2={119.23} y2={44.357} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint9_linear_2251_27739" x1={130.467} y1={73.299} x2={109.446} y2={56.884} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint10_linear_2251_27739" x1={133.804} y1={69.765} x2={90.823} y2={65.364} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint11_linear_2251_27739" x1={130.938} y1={69.463} x2={103.564} y2={66.664} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint12_linear_2251_27739" x1={123.331} y1={68.494} x2={111.72} y2={67.651} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint13_linear_2251_27739" x1={115.418} y1={61.927} x2={114.59} y2={66.993} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint14_linear_2251_27739" x1={121.872} y1={64.821} x2={121.442} y2={70.672} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint15_linear_2251_27739" x1={122.398} y1={63.029} x2={121.565} y2={68.128} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint16_linear_2251_27739" x1={116.396} y1={64.42} x2={115.967} y2={70.27} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint17_linear_2251_27739" x1={117.003} y1={62.149} x2={116.171} y2={67.248} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint18_linear_2251_27739" x1={120.19} y1={65.545} x2={119.518} y2={69.141} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint19_linear_2251_27739" x1={120.593} y1={62.735} x2={119.761} y2={67.834} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint20_linear_2251_27739" x1={111.365} y1={65.826} x2={130.248} y2={68.437} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint21_linear_2251_27739" x1={134.44} y1={45.447} x2={119.534} y2={44.046} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint22_linear_2251_27739" x1={104.297} y1={54.253} x2={131.033} y2={42.489} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint23_linear_2251_27739" x1={106.753} y1={59.831} x2={133.489} y2={48.066} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint24_linear_2251_27739" x1={105.979} y1={58.065} x2={132.715} y2={46.301} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint25_linear_2251_27739" x1={105.19} y1={56.272} x2={131.926} y2={44.508} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint26_linear_2251_27739" x1={97.731} y1={37.952} x2={77.247} y2={63.898} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint27_linear_2251_27739" x1={123.876} y1={39.094} x2={73.239} y2={47.842} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint28_linear_2251_27739" x1={69.254} y1={39.145} x2={81.755} y2={39.145} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint29_linear_2251_27739" x1={103.956} y1={53.472} x2={130.692} y2={41.707} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint30_linear_2251_27739" x1={116.904} y1={68.352} x2={94.963} y2={47.311} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={0.607} stopColor="#E7AD80" />
        <stop offset={0.926} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint31_linear_2251_27739" x1={122.83} y1={58.513} x2={100.352} y2={71.758} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint32_linear_2251_27739" x1={120.424} y1={65.262} x2={98.483} y2={44.222} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={0.607} stopColor="#E7AD80" />
        <stop offset={0.926} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint33_linear_2251_27739" x1={31.931} y1={3.277} x2={51.54} y2={43.954} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint34_linear_2251_27739" x1={15.378} y1={29.94} x2={38.078} y2={53.515} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint35_linear_2251_27739" x1={96.645} y1={191.557} x2={81.918} y2={159.076} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint36_linear_2251_27739" x1={99.104} y1={176.724} x2={73.427} y2={152.529} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint37_linear_2251_27739" x1={109.028} y1={161.344} x2={53.179} y2={207.34} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint38_linear_2251_27739" x1={27.74} y1={130.662} x2={45.209} y2={107.38} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint39_linear_2251_27739" x1={91.778} y1={6.694} x2={59.718} y2={62.265} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint40_linear_2251_27739" x1={76.176} y1={44.153} x2={43.838} y2={54.312} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint41_linear_2251_27739" x1={87.205} y1={173.779} x2={19.609} y2={159.292} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint42_linear_2251_27739" x1={164.833} y1={73.323} x2={5.018} y2={141.754} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint43_linear_2251_27739" x1={102.605} y1={79.314} x2={42.577} y2={169.86} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint44_linear_2251_27739" x1={121.52} y1={160.987} x2={77.884} y2={190.027} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint45_linear_2251_27739" x1={118.187} y1={155.979} x2={74.552} y2={185.02} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint46_linear_2251_27739" x1={124.35} y1={178.086} x2={81.161} y2={209.865} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint47_linear_2251_27739" x1={124.35} y1={178.086} x2={81.161} y2={209.865} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint48_linear_2251_27739" x1={127.48} y1={182.343} x2={84.292} y2={214.122} gradientUnits="userSpaceOnUse">
        <stop offset={0.254} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint49_linear_2251_27739" x1={66.626} y1={173.902} x2={14.657} y2={176.052} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint50_linear_2251_27739" x1={66.474} y1={187.38} x2={7.461} y2={191.974} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint51_linear_2251_27739" x1={68.918} y1={96.26} x2={39.443} y2={121.497} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint52_linear_2251_27739" x1={68.18} y1={99.597} x2={24.042} y2={123.673} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint53_linear_2251_27739" x1={73.957} y1={102.15} x2={44.481} y2={127.387} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint54_linear_2251_27739" x1={73.406} y1={101.503} x2={43.93} y2={126.74} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint55_linear_2251_27739" x1={71.99} y1={99.85} x2={42.514} y2={125.088} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint56_linear_2251_27739" x1={73.091} y1={101.137} x2={43.615} y2={126.374} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint57_linear_2251_27739" x1={72.411} y1={40.522} x2={61.796} y2={43.011} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint58_linear_2251_27739" x1={96.907} y1={43.742} x2={20.486} y2={85.921} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint59_linear_2251_27739" x1={65.219} y1={60.342} x2={25.592} y2={88.365} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint60_linear_2251_27739" x1={79.904} y1={33.094} x2={74.96} y2={17.492} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint61_linear_2251_27739" x1={82.673} y1={28.835} x2={67.155} y2={16.703} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint62_linear_2251_27739" x1={76.832} y1={32.202} x2={73.45} y2={21.736} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint63_linear_2251_27739" x1={78.458} y1={39.07} x2={68.138} y2={25.003} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint64_linear_2251_27739" x1={80.065} y1={23.361} x2={68.834} y2={10.282} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint65_linear_2251_27739" x1={74.456} y1={30.893} x2={51.24} y2={-0.306} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint66_linear_2251_27739" x1={79.636} y1={45.876} x2={54.874} y2={-0.534} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint67_linear_2251_27739" x1={95.805} y1={15.52} x2={66.588} y2={13.181} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="prefix__paint0_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(3.2258 0 0 3.22615 103.791 27.983)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint1_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.53145 0 0 1.53163 103.688 27.865)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint2_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(99.297 41.51) scale(.7702)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint3_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.62233 0 0 1.62252 138.806 62.99)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint4_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(.77018 0 0 .77018 138.76 62.932)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint5_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(35.2513 0 0 35.2658 122.615 45.772)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.192} stopColor="#E7AD80" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint68_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.36133 0 0 1.36197 140.575 56.438)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint69_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.36133 0 0 1.36197 102.194 33.035)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint70_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.36133 0 0 1.36197 113.682 27.687)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint71_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.36133 0 0 1.36197 139.11 33.767)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint72_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.7068 0 0 2.70809 138.987 43.882)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint73_radial_2251_27739"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.2851 0 0 1.28568 139.289 43.295)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);

export default ComplokWalkingMobile;
